<template>
    <div class="w-100">
        <section class="rates-table-section">
            <div class="container">
                <div class="rates-table-container">
                    <section class="title">
                        <h1>{{ $t('ratesTable.heading') }}</h1>
                        <h6 class="t-bold">{{ $t('ratesTable.subHeading') }}</h6>
                    </section>

                    <section class="rates-table-wrapper container">
                        <div class="row g-0 rates-table">
                            <lender-rates-item
                                class="col-12 lender-rate-card"
                                v-for="lender in lenders"
                                :key="lender.id"
                                :lender="lender"
                            />
                        </div>
                    </section>

                    <section class="showMoreLenders t-bold" v-if="lenders.length < totalLenderCount">
                        <span @click="showMoreLenders"
                            >{{ $t('ratesTable.showMoreLenders') }} <i class="fas fa-chevron-down"></i
                        ></span>
                    </section>

                    <section class="lenderTableFooter">
                        <span v-html="$t('ratesTable.meta')"></span>
                    </section>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import LenderRatesItem from '@js/components/LenderRatesItem'
import ApiRequest from '@js/utilities/apiRequest.js'

// lodash components
import chunk from 'lodash/chunk'
import concat from 'lodash/concat'

export default {
    components: {
        LenderRatesItem,
    },

    props: {
        territory: {
            default: '',
        },
    },

    mounted: function () {
        this.getLenders()
    },

    data() {
        return {
            loading: false,
            allLenders: [],
            lenders: [],
            totalLenderCount: 0,
            settings: {
                lenderChunkSize: 7,
            },
        }
    },

    methods: {
        getLenders: async function () {
            this.loading = true
            const responseData = await ApiRequest.get(this.$store, this.url(`/api/lenders`))

            if (responseData) {
                this.totalLenderCount = responseData.length
                this.allLenders = chunk(responseData, this.settings.lenderChunkSize)
                this.lenders = concat(this.lenders, this.allLenders[0])
                this.loading = false
            }
        },

        showMoreLenders() {
            var chunkToAdd = this.lenders.length / this.settings.lenderChunkSize

            this.lenders = concat(this.lenders, this.allLenders[chunkToAdd])
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.rates-table-container {
    margin: rem(40px) auto;
    max-width: rem(970px);

    @media screen and (min-width: $bp-large) {
        margin: rem(100px) auto;
    }

    .title {
        text-align: center;

        h1 {
            font-size: rem(30px);
            line-height: rem(36px);
            letter-spacing: -0.01em;
        }

        h6 {
            font-size: rem(18px);
            line-height: rem(22px);
            letter-spacing: -0.025em;
            color: var(--text-default);
            margin-top: rem(40px);
            margin-bottom: rem(40px);
        }
    }

    .showMoreLenders {
        color: var(--primary);
        margin-top: rem(20px);
        margin-bottom: rem(20px);
        text-align: center;
        cursor: pointer;

        @media screen and (min-width: $bp-large) {
            margin-top: rem(40px);
            margin-bottom: rem(40px);
        }

        svg {
            margin-left: rem(5px);
        }
    }

    .lenderTableFooter {
        color: var(--text-default);
        font-size: rem(14px);
        margin-bottom: rem(40px);
        text-align: center;
    }
}
</style>
